import { Component, ChangeDetectionStrategy, inject, input, output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { User } from 'shared';

import { AlertComponent } from '../../base/alert/alert.component';
import { ButtonComponent } from '../../base/button/button.component';
import { FormGridComponent } from '../../layouts';
import { LogoComponent } from '../../base/logo/logo.component';
import { TextInputComponent } from '../../form-inputs';

@Component({
  selector: 'lib-login-form',
  standalone: true,
  imports: [
    AlertComponent,
    ButtonComponent,
    FormGridComponent,
    FormsModule,
    LogoComponent,
    ReactiveFormsModule,
    TextInputComponent,
  ],
  templateUrl: './login-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {
  protected fb = inject(FormBuilder);

  readonly loginError = input(false);

  readonly loginRequest = output<User>();
  readonly passwordResetRequest = output<void>();

  loginForm = this.fb.group({
    emailAddress: ['', Validators.required],
    password: ['', Validators.required],
  });
  showFormErrors = false;

  submit() {
    if (this.loginForm.invalid) {
      this.showFormErrors = true;
      return;
    }

    this.loginRequest.emit(this.loginForm.value as User);
  }

  navigateToPasswordReset() {
    this.passwordResetRequest.emit();
  }
}
